import { Box, Stack } from "@vinomofo/components";

export interface SwipeableIndicatorProps {
  currentIndex: number;
  dots: number;
  onChangeIndex: (i: number) => void;
}

const IndicatorDot = ({
  active,
  ...rest
}: {
  active: boolean;
  onClick: () => void;
}) => {
  return (
    <Box
      width="10px"
      height="10px"
      borderRadius="5px"
      border="none"
      as="button"
      backgroundColor={active ? "brand" : "divider"}
      {...rest}
    />
  );
};

export const SwipeableIndicator = ({
  currentIndex,
  dots,
  onChangeIndex,
}: SwipeableIndicatorProps): JSX.Element => {
  const handleClick = (i) => onChangeIndex(i);

  const children = [];
  for (let i = 0; i < dots; i += 1) {
    children.push(
      <IndicatorDot
        key={i}
        active={i === currentIndex}
        onClick={() => handleClick(i)}
      />
    );
  }

  return (
    <Box display="flex" width="100%" justifyContent="center" marginTop="40px">
      <Stack horizontal space={1}>
        {children}
      </Stack>
    </Box>
  );
};
